import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { SettingsIcon } from 'components/Icons';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.object,
};

const SettingsThemedIcon = ({ className, width, height, theme }) => (
  <SettingsIcon className={className} width={width} height={height} fill={theme.color.settings} />
);

SettingsThemedIcon.propTypes = propTypes;

export default withTheme(SettingsThemedIcon);
